<script setup>
//https://flowbite.com/docs/components/breadcrumb/
import { ref, computed } from 'vue'
import { $bus } from '@/common/events'
import { $router } from '@/router'

const props = defineProps({
  items: {
    type: Object,
    default: [ "Home" ]
  }
});

const emit = defineEmits([ "click" ]);

const firstItem = computed(() => {
  return props.items && props.items.length ? props.items[0] : null;
});

const midItems = computed(() => {
  return props.items && props.items.length > 2 ? props.items.slice(1, props.items.length - 1) : null;
});

const lastItem = computed(() => {
  return props.items && props.items.length > 1 ? props.items[props.items.length - 1] : null;
});

function selectItem(item) {
  emit("click", item);
}
</script>

<template>
  <nav class="flex flex-col" aria-label="Breadcrumb">
    <ol class="inline-flex items-center space-x-1 md:space-x-3">
      <li class="inline-flex items-center" v-if="firstItem">
        <a href="#" @click.prevent="selectItem(firstItem)" class="inline-flex items-center text-lg font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
          <!-- <svg class="w-3 h-3 mr-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
          </svg> -->
          {{ firstItem && firstItem.name ? firstItem.name : firstItem }}
        </a>
      </li>
      <li v-for="item in midItems">
        <div class="flex items-center">
          <svg class="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
          </svg>
          <a href="#" @click.prevent="selectItem(item)" class="ml-1 text-lg font-medium text-gray-700 hover:text-blue-600 md:ml-2 dark:text-gray-400 dark:hover:text-white">{{ item && item.name ? item.name : item }}</a>
        </div>
      </li>
      <li aria-current="page" v-if="lastItem">
        <div class="flex items-center">
          <svg class="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
          </svg>
          <span class="ml-1 text-lg font-medium text-gray-500 md:ml-2 dark:text-gray-400">{{ lastItem && lastItem.name ? lastItem.name : lastItem }}</span>
        </div>
      </li>
    </ol>
  </nav>
</template>

<style scoped>
</style>
